import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { Routes } from './Routes';
import {
  Landing,
  LandingBase,
  PaymentFlow,
  PaymentValidation,
} from '../modules';
import { Consent } from '../modules';
import { RegistrationFlow } from '../modules/registration';
import {
  EditConsents,
  EditHealthData,
  Profile,
  ViewInvoices,
} from '../modules/profile';
import { LoginPage, Root } from '../shared_components';
import { Dashboard, SetGoal } from '../modules/dashboard';
import { ReportsLandingPage } from '../modules/reports/components/reportsLanding';
import {
  FitnessReportHistory,
  HeartHealthReportHistory,
  ReportBase,
  StressReportHistory,
  ReportOverview,
} from '../modules/reports';

export const createRoutes = (authenticated: boolean) => {
  return createBrowserRouter([
    {
      path: Routes.Root,
      Component: LandingBase,
      children: [
        {
          index: true,
          Component: Landing,
        },
        {
          path: Routes.Consent,
          Component: Consent,
        },
      ],
    },
    {
      path: Routes.Measurement,
      Component: Root,
      children: [
        {
          path: Routes.PaymentFlow,
          Component: PaymentFlow,
        },
        {
          path: Routes.PaymentValidation,
          Component: PaymentValidation,
        },
      ],
    },
    {
      Component: () => <Root hideLoginButton />,
      children: [
        {
          path: Routes.Register,
          Component: RegistrationFlow,
        },
      ],
    },
    {
      Component: Root,
      children: [
        {
          path: Routes.Reports,
          Component: ReportBase,
          children: [
            {
              path: Routes.Reports,
              Component: ReportsLandingPage,
            },
            {
              path: Routes.Overview,
              Component: ReportOverview,
            },
          ],
        },
      ],
    },
    {
      path: Routes.Login,
      Component: LoginPage,
    },
    ...authenticatedRoutes(authenticated),
    catchAllRoute,
  ]);
};

const authenticatedRoutes = (authenticated: boolean): RouteObject[] => {
  if (authenticated) {
    return [
      {
        Component: Root,
        children: [
          {
            path: Routes.Profile,
            Component: Profile,
          },
          {
            path: Routes.HealthData,
            Component: EditHealthData,
          },
          {
            path: Routes.EditConsents,
            Component: EditConsents,
          },
          {
            path: Routes.Invoices,
            Component: ViewInvoices,
          },
          {
            path: Routes.SetGoal,
            Component: SetGoal,
          },
          {
            path: Routes.Reports,
            Component: ReportBase,
            children: [
              {
                path: Routes.Dashboard,
                Component: Dashboard,
              },
              {
                path: Routes.FitnessReportHistory,
                Component: FitnessReportHistory,
              },
              {
                path: Routes.HeartHealthReportHistory,
                Component: HeartHealthReportHistory,
              },
              {
                path: Routes.StressReportHistory,
                Component: StressReportHistory,
              },
            ],
          },
        ],
      },
    ];
  }

  return [];
};

const catchAllRoute: RouteObject = {
  path: '*',
  Component: () => <Navigate to={Routes.Root} />,
};
